<style lang="less" scoped src="@/assets/less/manage-space/base.less"></style>

<template>
    <div>
        <b-form @submit.stop.prevent="saveAddress">
            <b-form-group
                id="input-company-name"
                :label="$t('labels.company')"
                label-for="input-company-name"
                label-class="label-align"
            >
                <b-form-input
                    v-model="form.Company"
                    :placeholder="$t('placeholders.companyname')"
                    class="form-control rounded-pill d-block"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                v-if="this.$unleash.isEnabled('frontend.billing.phone')"
                id="input-phone"
                :label="$t('labels.phonenumber')"
                label-for="input-phone"
                label-class="label-align"
            >
                <b-form-input
                    v-model="form.Phone"
                    :placeholder="$t('placeholders.phonenumber')"
                    class="form-control rounded-pill d-block"
                    type="tel"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="input-additional-info"
                :label="$t('labels.addressadditionalinformation')"
                label-for="input-additional-info"
                label-class="label-align"
            >
                <b-form-input
                    v-model="form.AdditionalInfo"
                    :placeholder="$t('placeholders.additionalinfo')"
                    class="form-control rounded-pill d-block"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="input-address"
                :label="$t('labels.address')"
                label-for="input-address"
                label-class="label-align"
            >
                <b-form-input
                    v-model="form.Address"
                    :placeholder="$t('placeholders.address')"
                    class="form-control rounded-pill d-block"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="input-postal-code"
                :label="$t('labels.postalcode')"
                label-for="input-postal-code"
                label-class="label-align"
            >
                <b-form-input
                    :placeholder="$t('placeholders.postalcode')"
                    v-model="form.PostalCode"
                    class="form-control rounded-pill d-block"
                ></b-form-input>
            </b-form-group>
            <b-form-group id="input-city" :label="$t('labels.city')" label-for="input-city" label-class="label-align">
                <b-form-input
                    :placeholder="$t('labels.city')"
                    v-model="form.City"
                    class="form-control rounded-pill d-block"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="input-country"
                :label="$t('labels.country')"
                label-for="input-country"
                label-class="label-align"
            >
                <b-form-input
                    :placeholder="$t('labels.country')"
                    v-model="form.Country"
                    class="form-control rounded-pill d-block"
                ></b-form-input>
            </b-form-group>
            <div class="d-flex justify-content-between w-100 m-0 mt-4">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <div class="d-flex">
                    <b-button size="sm" class="text-grey" @click="cancel()">{{ $t('labels.cancel') }}</b-button>
                </div>
                <b-button size="sm" variant="primary" type="submit">{{ $t('labels.save') }}</b-button>
            </div>
        </b-form>
    </div>
</template>
<script>
export default {
    name: 'EditAddress',
    props: {
        address: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            form: { ...this.address },
        };
    },

    methods: {
        cancel() {
            this.form = this.address;

            this.$emit('cancel');
        },
        saveAddress() {
            this.$emit('saveAddress', this.form);
        },
    },
};
</script>
